import { PathSettingsType } from "../../types/Layout";

export const PathSettings: Record<string, PathSettingsType> = {
  "car-2": { className: "car2-color", favicon: "favicon-4.png" },
  job: { className: "job-color", favicon: "favicon-5.png" },
  "job-2": { className: "job2-color large-container", favicon: "favicon-6.png" },
  "job-3": { className: "job3-color large-container", favicon: "favicon-7.png" },
  property: { className: "", favicon: "favicon-1.png" },
  "property-2": { className: "property2-color", favicon: "favicon-2.png" },
  default: { className: "car-color", favicon: "favicon-3.png" },
};

export const SearchModalData: { [key: string]: string } = {
  car: "car",
  property: "property",
  "property-2": "property",
  job: "job",
  "job-2": "job",
  "job-3": "job",
};
